import React, { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@mui/material/Box";
import cssClasses from "./AddPreference.module.css";
import Close from "../../Components/Icons/Close";
//Sub Components
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import DropDown from "../../Subcomponents/DropDown";
import TextField from "@mui/material/TextField";
import { Divider } from "@mui/material";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { useDispatch, useSelector } from "react-redux";

import backArrow from "../../Assets/Images/backArrow.svg";
import AddIcon from "../../Assets/Images/addSitePrefernces.svg";

//servcies
import {
  getProjectUnitType,
  getProjects,
  addProjectPrefernces,
  getLeadProjectPrefernce,
  updateProjectPrefernce,
  getAssignedProjects,
} from "../../Services/LeadService";
import { errorTost, successTost } from "../../Services/Toast";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { uniq, uniqBy } from "lodash";

const useStyles = makeStyles((theme) => ({
  radioLabel: {
    fontFamily: "Inter-Medium !important",
    fontSize: "1.6rem",
    lineHeight: "2.5rem",
  },
  prefernceNumber: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "1.2rem",
    lineHeight: "1.8rem",
    /* identical to box height, or 150% */

    /* Gray/500 */

    color: "#667085",
  },
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  TextFieldStyle: {
    width: "100%",
    background: "#F2F4F7 !important",
    paddingRight: "0rem !important",
    borderRadius: "10px !important",
    fontSize: "1.6rem !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "2.4rem !important",
  },
  inputStyle: {
    fontFamily: "Inter-Medium !important",
    paddingRight: "0rem !important",
    fontSize: "1.6rem !important",
    lineHeight: "2.4rem !important",
    background: "#F2F4F7  !important",
    //   border: '1px solid #D0D5DD',
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    borderRadius: "10px !important",
    border: "1px solid #F2F4F7",
    "& input": {
      fontSize: "1.6rem !important",
      lineHeight: "2.4rem !important",
      color: "#101828 !important",
      padding: "1.3rem 1.4rem",
      border: "none !important",
      boxShadow: "none !important",
    },

    "& input[text]": {
      color: "#101828 !important",
    },
    "& input[input:-internal-autofill-selected]": {
      background: "#F2F4F7 !important",
    },
    "& input[value]": {
      background: "#FFFFF !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused": {
      background: "#FFFFFF !important",
      border: "1px solid #84CAFF !important",
      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
    },
    "&.Mui-error": {
      border: "1px solid red !important",
      boxShadow: "none !important",
    },
  },

  helperText: {
    background: "#FFFFFF !important",
    fontSize: "1.4rem !important",
    margin: "0rem 0 0 0 !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "1.8rem !important",
    paddingTop: "0.5rem !important ",
  },
  closeIconModal: {
    cursor: "pointer",
    position: "absolute",
    right: "1rem",
    top: "1rem",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "0rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "3rem",
    lineHeight: "3.8rem",
    color: "#101828",
    marginBottom: "1.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.6rem",
    lineHeight: "2.4rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
}));

export default function AddPreference({ open, handleClose, returnRes, data }) {
  const classes = useStyles();
  const [projectFieldArray, setProjectFieldArray] = useState([
    {
      selectedProject: "",
      flatUnitType: "",
      isPrimary: true,
      alreadyAdded: false,
      availableUnitType:[],
    },
  ]);
  const helperTextObj = {
    selectedProject: "",
    flatUnitType: "",
  };
  const [projectFieldHelperText, setProjectFieldHelperText] = useState([
    helperTextObj,
  ]);
  const [projectNameList, setProjectNameList] = useState([]);
  const [projectUnitArray, setProjectUnitArray] = useState([]);
  const [checkPrimary, setCheckPrimary] = useState("");
  const [projectLength, setProjectLength] = useState(0);
  let loggedInUser = {};

  loggedInUser = useSelector((state) => state.Auth.user);
  useEffect(() => {
    getPreviousProjectPrefernce();
    // getProjects()
    //   .then((resp) => {
    //     console.log(resp);
    //     setProjectNameList(resp);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    getAssignedProjects(loggedInUser.cpId)
    .then((assignedProjectRes) => {
      assignedProjectRes= assignedProjectRes.filter((el)=>el.projectId!==null);
      assignedProjectRes=   assignedProjectRes.map((el)=>({...el,projectId:el?.projectId?.projectId,projectName:el?.projectId?.projectName,projectData:el?.projectId}))
      console.log({assignedProjectRes});
      setProjectNameList(assignedProjectRes);
    })
    .catch((err) => {
      console.log(err);
    });
  }, []);
  useEffect(() => {
    console.log(checkPrimary);
    console.log(projectFieldArray);
  }, [checkPrimary, projectFieldArray]);
  function getPreviousProjectPrefernce() {
    console.log(data);
    getLeadProjectPrefernce(data.personid).then((resp) => {
      console.log(resp);
      let tempArray = projectFieldArray;
      tempArray = resp[0].ProjectPreference.map((el, index) => {
        return {
          selectedProject: el.projectName,
          flatUnitType: el.unitType,
          isPrimary: el.isPrimary,
          alreadyAdded: true,
          projectPreferenceId: el.projectPreferenceId,
        };
      });
      setProjectLength(resp[0].ProjectPreference.length);
      setProjectFieldArray(tempArray);
      tempArray.forEach((el) => {
        if (el.isPrimary) {
          setCheckPrimary(el);
        }
      });
      setProjectFieldHelperText(tempArray.map((_) => helperTextObj));
    });
  }
  function funGetProjectUnitType(projectId,index) {
    // if (window.navigator.onLine) {
    getProjectUnitType(projectId)
      .then((resp) => {
        console.log(resp);
        resp = resp.map((el) => {
          if(el?.displaytype!==null&&el?.displaytype!==''){
            return el?.type+'('+el?.displaytype+')';
          }else{
            return el?.type;
          }
        });
        console.log(resp);
        setProjectFieldArray((pre)=>{
          pre[index].availableUnitType=resp;
          return[...pre];
        })
        setProjectUnitArray(resp);
      })
      .catch((err) => {
        // handleErrors(err, "add lead - get project unit type");
        errorTost(err.message);
      });
    // } else {
    //   offlineToast();
    // }
  }

  function validationProjectFields() {
    var form = true;
    projectFieldArray.forEach((el, index) => {
      if (el.selectedProject === "") {
        form = false;
        setProjectFieldHelperText((pre) => {
          pre[index].selectedProject = "Please Select Project First";
          return [...pre];
        });
      }
      if (el.flatUnitType === "") {
        form = false;
        setProjectFieldHelperText((pre) => {
          pre[index].flatUnitType = "Please Select Flat/Unit Type";
          return [...pre];
        });
      }
    });

    return {
      flag: form,
    };
  }

  function save() {
    console.log(checkPrimary);
    console.log({ projectLength }, { projectFieldArray });
    let flag = validationProjectFields();
    if (flag.flag) {
      let returnVal = false;
      if (projectLength < projectFieldArray.length) {
        presentLoader();
        projectFieldArray.forEach((el) => {
          if (el.alreadyAdded === false) {
      
            addProjectPrefernces(el, data.personid)
              .then((project) => {
                dismissLoader();
                console.log("projectPrefernce", project);
                closeModal();
                returnRes(true);
              })
              .catch((err) => {
                dismissLoader();
                // handleErrors(err, "add lead - project pref");
                errorTost(err.message);
              });
          }
          if (el.projectPreferenceId === checkPrimary.projectPreferenceId) {
            if (el.isPrimary === checkPrimary.isPrimary) {
              console.log("No update query");
              returnVal = false;
              closeModal();
              //no issue no update
            } else {
              console.log("update query");
              closeModal();
              returnRes(true);
              returnVal = true;
            }
          }
          if (returnVal) {
           
            projectFieldArray.forEach((el) => {
              updateProjectPrefernce(el.projectPreferenceId, el.isPrimary)
                .then((resp) => {
                  // successTost("Prefernce Updated Successfully");
                  closeModal();
                  returnRes(true);
                  console.log(resp);
                })
                .catch((err) => {
                  console.log(err);
                });
            });
          }
        });
        successTost("Prefernce Updated Successfully");
      } else {
        let returnVal = false;
        projectFieldArray.forEach((el) => {
          if (el.projectPreferenceId === checkPrimary.projectPreferenceId) {
            if (el.isPrimary === checkPrimary.isPrimary) {
              console.log("No update query");
              returnVal = false;
              //no issue no update
              closeModal();
            } else {
              console.log("update query");
              returnRes(true);
              returnVal = true;
            }
          }
        });
        if (returnVal) {
          successTost("Prefernce Updated Successfully");
          projectFieldArray.forEach((el) => {
            updateProjectPrefernce(el.projectPreferenceId, el.isPrimary)
              .then((resp) => {
                 
                closeModal();
                console.log(resp);
              })
              .catch((err) => {
                closeModal();
                console.log(err);
              });
          });
        }
      }
     
    }
  }
  function closeModal() {
    handleClose();
  }

  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          closeModal();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperHeader}>
          <span
            className={classes.closeIconModal}
            onClick={closeModal}
            tabIndex={0}
          >
            <Close width={"1.2rem"} height={"1.2rem"} />
          </span>
          <div>Add Preference</div>
        </div>
        <div className={cssClasses.wrapperContent}>
          <div className={cssClasses.wrapperContactDeatils}>
            <div className={cssClasses.wrapperProjectDeatils}>
              {projectFieldArray.map((each, index) => (
                <div
                  style={{
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    rowGap: "2rem",
                  }}
                >
                  <sapn className={classes.prefernceNumber}>
                    {index + 1} Preference
                  </sapn>
                  {index >= 1 && each.alreadyAdded === false ? (
                    <span
                      className={classes.closeIcon}
                      tabIndex={0}
                      onClick={() => {
                        projectFieldArray.forEach((each) => {
                          if (projectFieldArray[index].isPrimary) {
                            projectFieldArray[index - 1].isPrimary = true;
                          }
                        });
                        let arr = projectFieldArray;
                        arr.splice(index, 1);
                        setProjectFieldArray([...arr]);
                      }}
                    >
                      <Close width={"1.2rem"} height={"1.2rem"} />
                    </span>
                  ) : (
                    ""
                  )}
                  {each.alreadyAdded ? (
                    <>
                      <div>
                        <CustomInput
                          value={each.selectedProject}
                          disabled={true}
                          label={"Project"}
                          mandatory={true}
                        />
                      </div>
                      <div>
                        <CustomInput
                          value={each.flatUnitType}
                          disabled={true}
                          label={"Flat/Unit Type"}
                          mandatory={true}
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <div>
                        <div className={cssClasses.blockLabel}>
                          Project <span style={{ color: "red" }}> *</span>
                        </div>
                        <DropDown
                          list={projectNameList.map((element, id) => {
                            return {
                              label: element.projectName,
                              value: element.projectName,
                            };
                          })}
                          selectedValue={each.selectedProject}
                          onChangeSelect={(value) => {
                            setProjectFieldArray((pre) => {
                              console.log(pre[index]);
                              pre[index].selectedProject = value;
                              pre[index].flatUnitType = "";
                              return [...pre];
                            });
                            let selectedProject;
                            selectedProject = projectNameList.filter(
                              ({ projectName }) => value === projectName
                            );
                            funGetProjectUnitType(selectedProject[0].projectId,index);

                            setProjectFieldHelperText((pre) => {
                              pre[index].selectedProject = "";
                              return [...pre];
                            });
                            // each.selectedProject=value;
                          }}
                          placeHolder={"Select Project"}
                          //style.color is placeHolder's color
                          style={{
                            background: "#F2F4F7",
                            color: "rgb(102, 112, 133)",
                          }}
                          helperText={
                            projectFieldHelperText[index]?.selectedProject ?? ""
                          }
                          disable={each.alreadyAdded}
                        />
                      </div>
                      <div>
                        <div className={cssClasses.blockLabel}>
                          Flat/Unit Type
                          <span style={{ color: "red" }}> *</span>
                        </div>
                        <DropDown
                          list={uniq(each.availableUnitType)}
                          selectedValue={each.flatUnitType}
                          onChangeSelect={(value) => {
                            setProjectFieldArray((pre) => {
                              console.log(pre);
                              pre[index].flatUnitType = value;
                              return [...pre];
                            });
                            setProjectFieldHelperText((pre) => {
                              pre[index].flatUnitType = "";
                              return [...pre];
                            });
                            // each.selectedProject=value;
                          }}
                          placeHolder={"Flat/Unit Type"}
                          //style.color is placeHolder's color
                          style={{
                            background: "#F2F4F7",
                            color: "rgb(102, 112, 133)",
                          }}
                          helperText={
                            projectFieldHelperText[index]?.flatUnitType ?? ""
                          }
                          disable={each.alreadyAdded}
                        />
                      </div>
                    </>
                  )}

                  <div>
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        value={projectFieldArray[index].isPrimary}
                        sx={{
                          "& .MuiSvgIcon-root": {
                            color: "#155EEF !important",
                            fontSize: "2rem !important",
                          },
                        }}
                        onChange={(e) => {
                          projectFieldArray.forEach((el, arrayIndex) => {
                            setProjectFieldArray((pre) => {
                              pre = pre.map((m) => ({
                                ...m,
                                isPrimary: false,
                              }));
                              pre[index].isPrimary = true;
                              return [...pre];
                            });
                          });
                          console.log(projectFieldArray);
                        }}
                      >
                        <FormControlLabel
                          className={classes.radioLabel}
                          value={true}
                          control={<Radio />}
                          label={
                            <div className={classes.radioLabel}>
                              Mark as primary
                            </div>
                          }
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                  <div>
                    {projectFieldArray.length === index + 1 && (
                      // projectNameList.length >= projectFieldArray.length &&
                      <div className={cssClasses.wrapperAddPrefernce}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            columnGap: "1rem",
                          }}
                        >
                          <img src={AddIcon} alt={"addIcon"}></img>
                          <span
                            className={cssClasses.addPrefernceText}
                            onClick={() => {
                              let value = false;
                              value = projectFieldArray.every((el) => {
                                if (
                                  el.flatUnitType !== "" &&
                                  el.selectedProject !== ""
                                ) {
                                  return true;
                                } else {
                                  validationProjectFields();
                                  return false;
                                }
                              });
                              console.log(value);
                              if (value === true) {
                                let tempArray = projectFieldArray;
                                let helperText = projectFieldHelperText;
                                tempArray.push({
                                  selectedProject: "",
                                  flatUnitType: "",
                                  availableUnitType:[],
                                  isPrimary: false,
                                  alreadyAdded: false,
                                });
                                helperText.push({
                                  selectedProject: "",
                                  flatUnitType: "",
                                });
                                setProjectFieldArray([...tempArray]);
                                setProjectFieldHelperText([...helperText]);
                              }
                            }}
                          >
                            Add another Preference
                          </span>
                        </div>
                        {/* {index >= 1 && (
                            <span
                              className={cssClasses.addPrefernceText}
                              onClick={() => {
                                setProjectFieldArray((pre) => {
                                  pre.pop();
                                  return [...pre];
                                });
                              }}
                            >
                              Delete Preference
                            </span>
                          )} */}
                      </div>
                    )}

                    <Divider
                      sx={{
                        border: " 1px solid #98A2B3",
                        /* Shadow/xs */
                        boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                        marginBottom: "1rem",
                      }}
                    ></Divider>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className={cssClasses.wrapperFooter}>
          <div>
            <Button
              style={{
                color: "#344054",
                backgroundColor: "#ffffff",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              btnName={"Cancel"}
              clicked={() => {
                closeModal();
              }}
            />
          </div>
          <div>
            <Button
              style={{
                color: "#ffffff",
                backgroundColor: "#155EEF",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              btnName={"Save"}
              clicked={() => {
                save();
              }}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
}
